<app-vpackage-release *ngIf="vPackageService.packageOverview.type == 'vECUPKG'">
</app-vpackage-release>
<app-vpackage-release-content *ngIf="vPackageService.packageOverview.type != 'vECUPKG'"></app-vpackage-release-content>
